// extracted by mini-css-extract-plugin
export default {"menuBlock":"QE-z","title":"RE-z","nav":"SE-z","flexCell":"TE-z","facetLink":"UE-z"};